import { Actions } from 'vuex-smart-module';
import { ResponseStatuses } from '@/enums';
import { AxiosResponse } from 'axios';
import { Filters, FiltersPagination } from '@/types';
import { LastNotificationsService } from '../services';
import LastNotificationsState from './state';
import LastNotificationsMutations from './mutations';
import LastNotificationsGetters from './getters';
import { Notifications } from '../types';

const notificationsService = new LastNotificationsService();

export default class LastNotificationsActions extends Actions<
  LastNotificationsState,
  LastNotificationsGetters,
  LastNotificationsMutations,
  // eslint-disable-next-line no-use-before-define
  LastNotificationsActions
> {
  async get_last_notifs() {
    try {
      const { sortBy = [], sortDesc = [] } = this.state.table_options;
      const { current_page, limit } = this.state.pagination_props;
      const payload: any = {
        pagination: {
          limit,
          page: current_page,
          sort: '',
          sort_type: 'asc',
        },
      };
      const { data } = await notificationsService.get_last_notifs(payload);

      // console.log(data);
      this.mutations.SET_LAST_NOTIFICATIONS(data.items);
    } catch (error) {
      console.log(error);
    }
  }

  async read_notifs(id: number) {
    try {
      const { data } = await notificationsService.read_notifs(id);

      this.mutations.SET_LAST_NOTIFICATIONS(data.items);
    } catch (error) {
      console.log(error);
    }
  }
}
